module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/th/6-b7ae1efec36397b02c090f4b84c32124.jpg";